import Divider from 'apollo-react/components/Divider';
import Paper from 'apollo-react/components/Paper';
import Table from 'apollo-react/components/Table';
import React, { useRef } from 'react';

import ChangedRules from './ChangedRules';
import { useFormSelector, useTableLastRowVisibilityEffect } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getDeltaChangesForControl } from '../../selectors/form-manager.selectors';

const RULE_TYPES = ['update', 'interaction', 'validation'];

const isObject = (value) => (typeof value === 'object' && value !== null) || Array.isArray(value);

const ChangesTable = ({ id, isInsideExpandableRow }) => {
  const tableRef = useRef();
  const deltaChanges = useFormSelector(getDeltaChangesForControl, { id });

  const translateString = useTranslation();

  const columns = [
    {
      header: translateString('Property'),
      accessor: 'name',
      customCell: ({ row }) => <span style={{ fontWeight: '600' }}>{row.name}</span>,
    },
    {
      header: translateString('Custom Value'),
      accessor: 'currentValue',
    },
    {
      header: translateString('Out of the Box Value'),
      accessor: 'baseValue',
    },
  ];

  const commonChanges = deltaChanges
    .filter((c) => !RULE_TYPES.includes(c.name.toLowerCase()))
    .map((c) => ({
      ...c,
      currentValue: isObject(c.currentValue) ? JSON.stringify(c.currentValue) : c.currentValue,
      baseValue: isObject(c.baseValue) ? JSON.stringify(c.baseValue) : c.baseValue,
    }));
  const rulesChanges = deltaChanges.filter((c) => RULE_TYPES.includes(c.name.toLowerCase()));
  const hasCommonChanges = commonChanges.length > 0;
  const hasRulesChanges = rulesChanges.length > 0;
  const hasBothChanges = hasCommonChanges && hasRulesChanges;

  useTableLastRowVisibilityEffect({ tableRef, rows: commonChanges });

  const content = (
    <>
      {hasCommonChanges && <Table columns={columns} rows={commonChanges} hidePagination />}
      {hasBothChanges && !isInsideExpandableRow && <Divider />}
      {hasRulesChanges && <ChangedRules rulesChanges={rulesChanges} />}
    </>
  );

  return isInsideExpandableRow ? (
    <div ref={tableRef}>{content}</div>
  ) : (
    <Paper ref={tableRef} style={{ maxWidth: 400 }}>
      {content}
    </Paper>
  );
};

export default ChangesTable;
